import { forwardRef } from "react";

import { PickerDateProps } from "antd/lib/date-picker/generatePicker";
import { clsx } from "clsx";
import { Dayjs } from "dayjs";

import { RVDatePickerDayJSFacade } from "../RVDatePickerDayJSFacade/RVDatePickerDayJSFacade";

import styles from "./RVDatePicker.module.scss";

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

/**
 * Props for `RVDatePicker`.
 */
export type RVDatePickerProps = Optional<PickerDateProps<Dayjs>, "picker"> & {
    /** Optional className applied to the picker popup. */
    popupClassName?: string;
};

/**
 * Regal Voice Date Picker component using Dayjs and Ant Design.
 *
 * @remarks
 * This is a styled wrapper around the Ant Design DatePicker, using Dayjs for date management.
 * Use this for all date picking needs in the app for consistency.
 *
 * @param props All AntD date picker props except `picker`, which is fixed to `date`.
 * @returns Styled date picker facade instance.
 */
export const RVDatePicker = forwardRef<any, RVDatePickerProps>((props: RVDatePickerProps, ref) => {
    return (
        <RVDatePickerDayJSFacade
            picker="date"
            {...props}
            mode={undefined}
            ref={ref}
            className={clsx(styles.timepicker, props.className || "")}
            popupClassName={clsx(styles.timepicker, props.popupClassName || "")}
        />
    );
});

RVDatePicker.displayName = "RVDatePicker";
